var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "android_faq", staticStyle: { "margin-top": "92px" } },
    [
      _c("p", { staticClass: "category_big" }, [
        _c("b", [_vm._v(_vm._s(_vm.title))])
      ]),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "accordion accordion-flush",
          attrs: { id: "accordionExample" + _vm.accordionId }
        },
        _vm._l(_vm.list, function(item, index) {
          return _c("div", { staticClass: "accordion-item" }, [
            _c(
              "h2",
              {
                staticClass: "accordion-header",
                attrs: { id: "heading" + item.id }
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "accordion-button collapsed",
                    attrs: {
                      type: "button",
                      "data-bs-toggle": "collapse",
                      "data-bs-target": "#collapse" + item.id,
                      "aria-expanded": "false",
                      "aria-controls": "collapse" + item.id
                    }
                  },
                  [_vm._v("\n          " + _vm._s(item.sbjctNm) + "\n        ")]
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "accordion-collapse collapse",
                attrs: {
                  id: "collapse" + item.id,
                  "aria-labelledby": "heading" + item.id,
                  "data-bs-parent": "#accordionExample" + _vm.accordionId
                }
              },
              [
                _c(
                  "div",
                  { staticClass: "accordion-body" },
                  [
                    _vm._l(item.appFaqSubs, function(sub, index) {
                      return [
                        sub.subtitlNm != null && sub.subtitlNm !== ""
                          ? _c("div", { staticClass: "android_solution" }, [
                              _c("p", [
                                _vm._v(
                                  "\n                " +
                                    _vm._s(sub.subtitlNm) +
                                    "\n              "
                                )
                              ])
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "carousel slide",
                            attrs: {
                              id: "carousel_faq_finish_" + sub.id,
                              "data-bs-ride": "carousel",
                              "data-bs-interval": "false",
                              "data-bs-wrap": "false"
                            }
                          },
                          [
                            _c(
                              "div",
                              { staticClass: "carousel-indicators" },
                              [
                                _vm._l(5, function(i) {
                                  return sub["attFileN" + i] != ""
                                    ? [
                                        i == 1
                                          ? _c("button", {
                                              ref: "firstSlideButton",
                                              refInFor: true,
                                              staticClass: "active",
                                              attrs: {
                                                type: "button",
                                                "data-bs-target":
                                                  "#carousel_faq_finish_" +
                                                  sub.id,
                                                "data-bs-slide-to": i - 1,
                                                "aria-current": "true",
                                                "aria-label": "Slide " + i
                                              }
                                            })
                                          : _c("button", {
                                              attrs: {
                                                type: "button",
                                                "data-bs-target":
                                                  "#carousel_faq_finish_" +
                                                  sub.id,
                                                "data-bs-slide-to": i - 1,
                                                "aria-label": "Slide " + i
                                              }
                                            })
                                      ]
                                    : _vm._e()
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "carousel-inner" },
                              [
                                _vm._l(5, function(i) {
                                  return sub["attFileN" + i] != ""
                                    ? [
                                        i == 1
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "carousel-item active"
                                              },
                                              [
                                                _c("img", {
                                                  staticClass: "d-block w-100",
                                                  attrs: {
                                                    src: sub["attFileN" + i],
                                                    alt: sub["attFileNameN" + i]
                                                  }
                                                })
                                              ]
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "carousel-item" },
                                              [
                                                _c("img", {
                                                  staticClass: "d-block w-100",
                                                  attrs: {
                                                    src: sub["attFileN" + i],
                                                    alt: sub["attFileNameN" + i]
                                                  }
                                                })
                                              ]
                                            )
                                      ]
                                    : _vm._e()
                                })
                              ],
                              2
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "carousel-control-prev",
                                attrs: {
                                  type: "button",
                                  "data-bs-target":
                                    "#carousel_faq_finish_" + sub.id,
                                  "data-bs-slide": "prev"
                                }
                              },
                              [
                                _c("span", {
                                  staticClass: "carousel-control-prev-icon",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "visually-hidden" }, [
                                  _vm._v("Previous")
                                ])
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "carousel-control-next",
                                attrs: {
                                  type: "button",
                                  "data-bs-target":
                                    "#carousel_faq_finish_" + sub.id,
                                  "data-bs-slide": "next"
                                }
                              },
                              [
                                _c("span", {
                                  staticClass: "carousel-control-next-icon",
                                  attrs: { "aria-hidden": "true" }
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "visually-hidden" }, [
                                  _vm._v("Next")
                                ])
                              ]
                            )
                          ]
                        )
                      ]
                    })
                  ],
                  2
                )
              ]
            )
          ])
        }),
        0
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4aabfccf", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4aabfccf","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/FaqListView.vue
// module id = null
// module chunks = 